import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

/**
 * Route guard component to protect mentor-only routes
 * - Allows authenticated users to access /mentor-profile/me (profile creation/completion)
 * - Blocks mentor-only features (like sessions) for non-mentors
 */
const MentorRouteGuard = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn, user, experiences } = useSelector((state) => state);
  
  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    toast.error('Please log in to access this page', { autoClose: 3000 });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // UNIFIED ACCOUNT: Check both user properties and experiences state
  const isMentor = user?.isMentor || user?.role === "mentor" || experiences?.mentor?.active || experiences?.mentor?.hasProfile;
  
  // Allow students to access /mentor-profile/me to complete their mentor profile
  if (location.pathname === '/mentor-profile/me') {
    return children;
  }
  
  // If logged in but not a mentor, redirect to dashboard with message
  if (!isMentor) {
    toast.error('This page is only accessible to mentors', { autoClose: 3000 });
    return <Navigate to="/dashboard" replace />;
  }
  
  // If user is logged in and is a mentor, render the protected route
  return children;
};

export default MentorRouteGuard;
